import React, {Component} from 'react';

class BoxValidateButton extends Component {
    render() {
        return (
            <button onClick={(e) => this.props.clickAction()}>Valider</button>
        );
    }
}

export default BoxValidateButton;